import { TextField, TextFieldProps } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from 'i18n';
import { AddressAutofillController } from "./useAddressAutofillController";

interface Props {
  value: string;
  onChange: (value: string) => void;
  addressAutofill?: AddressAutofillController;
  textFieldProps?: TextFieldProps;
}

const Street = ({
  value,
  onChange,
  addressAutofill,
  textFieldProps
}: Props) => {
  const {t} = useTranslation();

  useEffect(() => {
    if (addressAutofill) {
      const newStreetValue = addressAutofill.newValues.street;
      if (newStreetValue !== value) { 
        onChange(newStreetValue ?? '');
      }
    }
  }, [addressAutofill?.newValues.street, value, onChange]);

  return (
    <TextField 
      variant='standard'
      label={`${t('lang.street')}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      {...textFieldProps}
    />
  )
}
export default Street;